module.exports = __webpack_public_path__ + "static/media/flatBedTruck_navy.6b9de16d.svg";